<template>

    <div class="h-24 border-transparent border overflow-hidden bg-box rounded shadow mb-2 flex" >
        <div class="flex-none w-24 bg-cover bg-center cursor-pointer"
             v-if="product.image" 
             :style="'background-image:url('+product.image+')'" 
             @click="openProduct(product.id)">
        </div>
        <div class="flex-none w-24 bg-cover bg-center cursor-pointer"
             v-else 
             style="background-image:url('images/logotipo-la-tienda-de-valentina.jpg')" 
             @click="openProduct(product.id)">
        </div>
        <div class="flex-1 overflow-hidden p-2 flex flex-col">
            <div class="flex">

                <Request model="stock/SetToggleChecked" @success="updateProductList" action="update" :form="{id:product.id}"  v-slot="{request,loading}">
                    <div>
                        <button @click="request">
                            <div class="mr-2" >
                                <i class="mdi mdi-check-bold text-aux" v-if="product.is_checked"></i>
                                <i class="mdi mdi-check-outline text-aux-30" v-else></i>
                            </div> 
                        </button>
                    </div>
                </Request>

                <div class="flex-1 overflow-hidden font-light">
                    {{product.name}}
                </div>   

            </div>
            <div class="flex-1 overflow-hidden flex">
                <div v-for="variation in product.variants" class="mr-1  flex flex-col w-12">
                    <div class="w-full flex bg-module items-center justify-center h-full rounded overflow-hidden" :class="'stock-'+variation.stock_class">
                        {{variation.stock}}
                    </div>
                    <small class="w-full flex items-center justify-center leading-none pt-1" v-if="variation.name !== 'Default Title'">
                        {{variation.name}} 
                    </small>

                </div>

            </div>
        </div>
        <div class="flex-none w-20">
            <div class="flex-none text-aux text-xl font-bold">
                {{product.price | numberFormat(2)}}<small class="text-aux-60">€</small><br>
                <span class="text-font-gray">
                    {{product.scoring | numberFormat(0)}}<small class="text-font-dark">Uds.</small>
                </span>

            </div>  
        </div>
        <div class="flex-none w-24">
            <chart-stock-donnut :data="product.stock_percent">
                <div class="flex flex-col items-center justify-center text-aux-60">
                    <div class="leading-none text-xl">{{product.sales_out_stock}}</div>
                </div>
            </chart-stock-donnut>
        </div>
    </div>

</template>
<script>

    import chartStockDonnut from '@/components/chartStockDonnut.vue';
    import { state,actions } from '@/store';
    import { Request } from '@/api/components';
    export default {
        name: 'product-summary',
        props: ['product','modalPosition'],
        components:{
            chartStockDonnut,
            Request
        },
        data(){
            return {
                holaModel:''
            }  
        },
        methods:{
            updateProductList(){
                this.$emit('updateProductList')
            },
            openProduct(id){
                this.$emit('setModalPosition',this.modalPosition)
                actions.openProduct(id)
            }
        }
    }
</script>